//活动配置
const RechargeConfiguration = () => import(/*webpackChunkName:'active-configuration'*/'@/page/system/activeConfiguration/rechargeConfiguration.vue')
const RouteTemp = () => import(/*webpackChunkName:'system'*/'@/page/commons/routeTemp.vue')

export const activeConfiguration={
    path: '/main/active-configuration',
    name: '活动配置',
    component: RouteTemp,
    meta: {
        requireAuth: true,
    },
    children: [{
        path: '/main/active-configuration/recharge-configuration',
        name: '充值配置',
        component: RechargeConfiguration,
        meta: {
            requireAuth: true,
        },
    }]
}